import { render, staticRenderFns } from "./step4XIAOHSCom.vue?vue&type=template&id=f260d07a&scoped=true"
import script from "./step4XIAOHSCom.vue?vue&type=script&lang=js"
export * from "./step4XIAOHSCom.vue?vue&type=script&lang=js"
import style0 from "./step4XIAOHSCom.vue?vue&type=style&index=0&id=f260d07a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f260d07a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f260d07a')) {
      api.createRecord('f260d07a', component.options)
    } else {
      api.reload('f260d07a', component.options)
    }
    module.hot.accept("./step4XIAOHSCom.vue?vue&type=template&id=f260d07a&scoped=true", function () {
      api.rerender('f260d07a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/guidance/steps/step4XIAOHSCom.vue"
export default component.exports